module.exports = __webpack_public_path__ + "fonts/CalibreMedium.48619aaa.woff";